export default {
  login: {
    label: {
      title1: '受付番号',
      title2: 'パスワード'
    }
  },
  entry: {
    title1: 'コース名:',
    title2: '商品番号'
  },
  confirm: {
    title1: 'コース名:',
    title2: '商品番号'
  }
}



// WEBPACK FOOTER //
// ./src/lang/locales/ja/pages.js